import events from './events'
import store from 'reducers'
import Actions from './Actions'
import dayjs from 'dayjs'

export default class AvailabilityActions extends Actions{
    static get target(){
        return 'availabilities'
    }

    static fetch (data) {
        let refreshSyncData = {
            organizationID: data.organizationID,
            date: dayjs(data.startingAt).format('YYYY-MM-DD'),
            numberOfDays: dayjs(data.endingAt).diff(dayjs(data.startingAt), 'days') + 1
        }
        
        return this.client.organizations.refreshSync(refreshSyncData).then(()=>(
            this.client.organizations.availabilities.fetch(data)
        ))
    }

    static clear(){
        this.set({})
    }
}


// WEBPACK FOOTER //
// ./actions/AvailabilityActions.js